import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import form_styles from "../../Form/Form.module.css";
import stylesSearch from "../../Search/Search.module.css";
import stylesField from "../../Field/Field.module.css";
import FieldCustom from "../../Field/FieldCustom";
import styles from "../../../pages/Admin/Admin.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import FieldUpload from "../../Field/FieldUpload";
import modalSuccess from "../../Modal/ModalSuccess";
import {useModal} from "../../../contexts/ModalContext";
import {Link, useNavigate, useParams, useSearchParams} from "react-router-dom";
import TitleSecondary from "../../Title/TitleSecondary";
import SearchEntreprise from "../../Search/SearchEntreprise";
import FieldCheckbox from "../../Field/FieldCheckbox";
import FieldCheckboxArray from "../../Field/FieldCheckboxArray";
import BtnSave from "../../Button/BtnSave";
import {fetchEntreprisesSelect, fetchGetEntreprise} from "../../../services/EntrepriseService";
import {getUtilisateurRoleLabel} from "../../../services/UserService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong} from "@fortawesome/free-solid-svg-icons";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import SearchCoach from "../../Search/SearchCoach";
import DateService from "../../../services/DateService";
import Routing from "../../../services/routing";
import {fetchTypesActivite} from "../../../services/ActivitesService";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";

function UtilisateurCreation({ utilisateur = null }) {
    const { user } = useUser();
    const {showModal, hideModal} = useModal();
    const formikRef = React.useRef();
    const [roles, setRoles] = useState([]);
    const [civilites, setCivilites] = useState([]);
    const [searchParams] = useSearchParams();
    const urlRole = searchParams.get('role') || null;
    const entrepriseId = searchParams.get('entreprise') || null;
    const initialRoles = urlRole ? [urlRole] : utilisateur?.roles || [];
    const [typesActivite, setActiviteTypes] = useState([]);
    const [entreprise, setEntreprise] = useState({});
    const [generatePassword, setGeneratePassword] = useState("");
    let navigate = useNavigate();
    const [entreprisesSelect, setEntreprisesSelect] = useState([]);

    const initialValues = {
        prenom: utilisateur?.prenom || "",
        nom: utilisateur?.nom || "",
        email: utilisateur?.email || "",
        tel_mobile: utilisateur?.tel_mobile || "",
        login: utilisateur?.email || "",
        civilite: utilisateur?.civilite?.id || "",
        entreprise: utilisateur?.entreprise?.id || "",
        status: utilisateur?.status || "0",
        date_naissance: utilisateur?.date_naissance ? DateService.formatDateWithoutTime(utilisateur.date_naissance) : "",
        selectedRoles: initialRoles || [],
        utilisateur: utilisateur?.id || "",
        can_connect: utilisateur?.can_connect || true,
        desactiver: utilisateur?.actif === false,
        activite_types: utilisateur?.activiteTypes?.map((activite) => activite.id.toString()) || [],
        entAdmin: utilisateur?.entAdmin?.map((entAdmin) => entAdmin?.id?.toString()) || [],
    };

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const handleSubmit = async (values, {setSubmitting}) => {
        values.utilisateur = utilisateur?.id || "";
        if (entreprise.entrepriseId) {
            values.entreprise = entreprise.entrepriseId;
        } else if (entreprise.id) {
            values.entreprise = entreprise.id;
        } else if (utilisateur && utilisateur.entreprise && utilisateur.entreprise.id) {
            values.entreprise = utilisateur.entreprise.id;
        } else {
            values.entreprise = null;
        }

        if (
            values.selectedRoles.includes("ROLE_COACH")
            || values.selectedRoles.includes("ROLE_ADMIN")
            || values.selectedRoles.includes("ROLE_SUPER_ADMIN")
        ) {
            values.entreprise = null;
        }

        values.user_id = utilisateur?.id || "";

        try {
            const response = await AxiosConfig.post(`/admin/utilisateurs/creation`, values);

            if (response.data.success) {
                setGeneratePassword(response.data.res.generatePass);
                handleSuccess();
                // Redirect to the user page
                navigate(`${
                    Routing.generate({
                        route: Routing.routes.adminUtilisateur,
                        params: { utilisateurId: response.data.res.user }
                    })
                }`);
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    useEffect(() => {
        const fetchRoles = async () => {
            const response = await AxiosConfig.get(`/admin/roles`);
            if (response.data.success) {
                setRoles(response.data.myRoles);
            } else {
                console.error('error', response.data);
                handleError("Erreur lors de la récupération des rôles");
            }
        }
        fetchRoles();
        const fetchCivilite = async () => {
            const response = await AxiosConfig.get(`/admin/utilisateurs/civilites`);

            if (response.data.success) {
                setCivilites(response.data.myCivilites);
            } else {
                console.error('error', response.data);
                handleError("Erreur lors de la récupération des civilités");
            }
        }
        fetchCivilite();
    }, []);



    const renderSelectActiviteTypeOld = () => {
        if (!utilisateur?.roles?.includes("ROLE_COACH")) {
            return ;
        }

        if (typesActivite.length === 0) {
            return <p>Chargement ...</p>;
        }

        const handleChange = (values) => {
            // Build input hidden with selected types and display them in span

        }

        return (
            <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "6px"
            }}>
                <Field as="select" multiple={true} name="type" onChange={handleChange}
                       style={{borderRadius: "16px"}}>
                    <option>
                        -- Ajoutez un type d'activité --
                    </option>
                    {typesActivite.map((type, index) => (
                        <option key={index} value={type.value.toString()}>
                            {type.label}
                        </option>
                    ))}
                </Field>
                <Link to={Routing.routes.adminActiviteTypesCreation} title={"Créer un type d'activité"}
                      className={styles.btnAdd}>
                    <AjouterIcone/>
                </Link>
            </div>
        );
    }

    const renderSelectActiviteType = ({ utilisateur, setFieldValue, values }) => {
        if (!utilisateur?.roles?.includes("ROLE_COACH")) {
            return null;
        }

        if (typesActivite.length === 0) {
            return <p>Chargement ...</p>;
        }

        const handleChange = (event, type) => {
            const updatedTypes = event.target.checked
                ? [...values.activite_types, type]
                : values.activite_types.filter(t => t !== type);
            setFieldValue('activite_types', updatedTypes);
        };

        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px"
            }}>
                <span style={{fontWeight: "bold"}}>Sélectionner des types d'activité :</span>
                {typesActivite.map((type, index) => (
                    <div key={index} style={{
                        display: type.value === "toutes" ? "none" : "flex",
                        alignItems: "center",
                        gap: "8px",
                        width: "min-content"}}>
                        <input
                            type="checkbox"
                            id={`type-${type.value}`}
                            checked={values.activite_types.includes(type.value.toString())}
                            onChange={(event) => handleChange(event, type.value.toString())}
                            style={{width: "1rem", height: "1rem"}}
                        />
                        <label htmlFor={`type-${type.value}`}>{type.label}</label>
                    </div>
                ))}
                <Link to={Routing.routes.adminActiviteTypesCreation} title={"Créer un type d'activité"} className={styles.btnAdd}>
                    <AjouterIcone/>
                </Link>
            </div>
        );
    };

    const renderSelectAdminEntreprise = ({ utilisateur, setFieldValue, values }) => {
        if (!utilisateur?.roles?.includes("ROLE_ADMIN")) {
            return null;
        }

        if (entreprisesSelect.length === 0) {
            return <p>Chargement ...</p>;
        }

        const handleChange = (event, type) => {
            const current = Array.isArray(values.entAdmin) ? values.entAdmin : [];

            const updated = event.target.checked
                ? [...current, type]
                : current.filter(t => t !== type);

            setFieldValue('entAdmin', updated);
        };

        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "26px",
            }}>
                <span style={{ fontWeight: "bold" }}>Sélection des entreprises à administrer :</span>

                {entreprisesSelect.map((type, index) => (
                    <div key={index} style={{
                        display: type.id === "toutes" ? "none" : "flex",
                        alignItems: "center",
                        gap: "8px",
                        width: "min-content"
                    }}>
                        <input
                            type="checkbox"
                            id={`type-${type.id}`}
                            checked={values.entAdmin?.includes(type.id.toString())}
                            onChange={(event) => handleChange(event, type.id.toString())}
                            style={{width: "1rem", height: "1rem"}}
                        />
                        <label htmlFor={`type-${type.id}`}>{type.label}</label>
                    </div>
                ))}
            </div>
        );
    };

    useEffect(() => {
        if (utilisateur && utilisateur.entreprise) {
            setEntreprise({
                query: utilisateur.entreprise.nom,
                id: utilisateur.entreprise.id,
                addr: utilisateur.entreprise.addr,
                cp: utilisateur.entreprise.cp,
                ville: utilisateur.entreprise.ville,
                pays: utilisateur.entreprise.pays
            });
        }
        if (entrepriseId) {
            (async () => {
                const response = await fetchGetEntreprise(entrepriseId);
                if (response.success){
                    setEntreprise({
                        query: response.myEntreprise.nom,
                        id: entrepriseId,
                        addr: response.myEntreprise.addr,
                        cp: response.myEntreprise.cp,
                        ville: response.myEntreprise.ville,
                        pays: response.myEntreprise.pays
                    });
                }
            } )();
        }
    }, [utilisateur, entrepriseId]);

    useEffect(() => {
        if (utilisateur?.roles?.includes("ROLE_COACH")) {
            const getTypesActivite = async () => {
                const response = await fetchTypesActivite();
                setActiviteTypes(response.types);
            };
            getTypesActivite();
        }

        if (utilisateur?.roles?.includes("ROLE_ADMIN")) {
            const getEntrSelect = async () => {
                const response = await fetchEntreprisesSelect();
                setEntreprisesSelect(response.data);
            };
            getEntrSelect();
        }
    }, [utilisateur]);

    if (!entreprise) {
        return <p>Chargement...</p>;
    }

    const renderSelectStatus = () => {
        return (
        <div className={stylesField.select}>
            <span style={{marginBottom: "0.25rem", paddingLeft: "0.5rem"}}>Status</span>
            <Field as="select" name="status">
                <option>
                    -- Sélectionnez un statut --
                </option>
                <option value={"-2"}>
                    En attente de justificatifs
                </option>
                <option value={"-1"}>
                    Coach: Attente validation par un Administrateur
                </option>
                <option value={"0"}>
                    Importé
                </option>
                <option value={"1"}>
                    Compte créé
                </option>
                <option value={"3"}>
                    Compte bloqué
                </option>
            </Field>
        </div>
        );
    }

    const renderSelectRoles = (handleCheckboxChange, roles) => {
        return (
            <div className={styles.formBloc} style={{
                display: "flex",
                flexDirection: "column",
                margin: "16px 0",
                padding: "14px",
                border: "1px solid var(--clr-accent)",
                borderRadius: "10px"
            }}>
                <h3>Rôles</h3>
                {roles.map((role, index) => (
                    <FieldCheckboxArray
                        key={index}
                        name="selectedRoles"
                        value={role.role}
                        label={getUtilisateurRoleLabel(role.role)}
                        onChange={(e) => handleCheckboxChange(role.role, e.target.checked)}
                    />
                ))}
            </div>);
    }

    const renderSelectCivilite = () => {
        return (<div className={stylesField.select}>
                                            <span
                                                style={{marginBottom: "0.25rem", paddingLeft: "0.5rem"}}>Civilité</span>
            <Field as="select" name="civilite">
                <option>-- Sélectionnez une civilité --</option>
                {civilites?.map((civilite, index) => (
                    <option key={index} value={civilite.id}>
                        {civilite.label}
                    </option>
                ))}
            </Field>
        </div>)
    }

    const renderEntreprise = (u) => {
        if (!u || u.entreprise) {
            return (
            <div className={stylesSearch.entrepriseContainer}>
                <p>Entreprise</p>
                <SearchEntreprise selectedEntreprise={utilisateur?.entreprise}
                                  onSubmit={(e) => {
                                      setEntreprise(e);
                                  }}/>

                <p style={{fontSize: "var(--fs-secondary)", marginTop: "6px", color: "#226a00", fontWeight: "bold"}}>
                    Entreprise sélectionnée :
                    {(entreprise && entreprise.id) ? (
                        <>
                            <Link to={`/admin/entreprises/${entreprise.id}`}> {entreprise.query} </Link>
                            <span>{entreprise?.addr}, {entreprise?.cp} {entreprise?.ville}, {entreprise?.pays}</span>
                        </>
                    ) : ((entreprise && entreprise.entrepriseId) ? (
                        <>
                            <Link to={`/admin/entreprises/${entreprise.entrepriseId}`}> {entreprise.query} </Link>
                        </>
                    ) : (
                        (utilisateur?.entreprise && utilisateur?.entreprise?.id) ?
                            <>
                                <Link
                                    to={`/admin/entreprises/${utilisateur.entreprise?.id}`}> {utilisateur.entreprise.nom} </Link>
                                <span>{utilisateur.entreprise.addr}, {utilisateur.entreprise.cp} {utilisateur.entreprise.ville}, {utilisateur.entreprise.pays}</span>
                            </>
                            : <span style={{color: "var(--clr-danger)"}}> Aucune</span>))}

                </p>
            </div>);
        }

        return <></>;
    }


    return (
        <div className={styles.viewBloc} style={{margin: '0 0 50px 0'}}>
            {Object.keys(initialValues).length > 0 ? (
                <>
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                    innerRef={formikRef}
                >
                    {({isSubmitting, setFieldValue, values}) => {
                        const handleCheckboxChange = (role, isChecked) => {
                            const updatedRoles = isChecked
                                ? [...values.selectedRoles, role]
                                : values.selectedRoles.filter(r => r !== role);

                            if (role === "ROLE_COACH" && isChecked === true) {
                                // Afficher le select activiteTypess

                            }

                            setFieldValue('selectedRoles', updatedRoles);
                        };

                        return (
                            <>
                                {/* Si Le role coach est séléctionné il ne faut pas afficher le bloc renderEntreprise */}
                                {(values.selectedRoles.includes("ROLE_COACH")
                                    || values.selectedRoles.includes("ROLE_ADMIN"))
                                    || values.selectedRoles.includes("ROLE_SUPER_ADMIN")
                                    ? null : (
                                        <div>
                                            {renderEntreprise(utilisateur)}
                                        </div>
                                )}

                                <Form className={styles.form}>
                                    <div className={`${styles.presentationContainer} ${stylesField.adminForm}`}>
                                        {renderSelectCivilite()}

                                        <FieldCustom type={"text"} name={"prenom"} label={"Prénom"}/>
                                        <FieldCustom type={"text"} name={"nom"} label={"Nom"}/>
                                        <FieldCustom type={"date"} name={"date_naissance"}
                                                     label={"Date de naissance"}/>
                                        <FieldCustom type={"email"} name={"email"} label={"Email"}/>
                                        <FieldCustom type={"text"} name={"tel_mobile"} label={"Téléphone mobile"}/>

                                        {renderSelectStatus()}
                                        {renderSelectRoles(handleCheckboxChange, roles)}

                                        { utilisateur?.roles?.includes("ROLE_COACH") && renderSelectActiviteType({ utilisateur, setFieldValue, values })}
                                        { utilisateur?.roles?.includes("ROLE_ADMIN") && renderSelectAdminEntreprise({ utilisateur, setFieldValue, values })}

                                        <FieldCheckbox type={"checkbox"} name={"can_connect"}
                                                       label={"Peut se connecter"}/>

                                        <FieldCheckbox type={"checkbox"} name={"desactiver"}
                                                       label={"supprimer cet utilisateur"}/>
                                    </div>

                                    <div className={"barre_btn"}>
                                        <button type={"button"} onClick={() => {
                                            navigate(-1)
                                        }} className={"btn btn_danger"}><AnnulerIcone/>Annuler
                                        </button>
                                        <BtnSave isSubmitting={isSubmitting}/>
                                    </div>
                                </Form>

                                {generatePassword &&
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        margin: "10px"
                                    }}>
                                        <h4>Mot de passe généré</h4>
                                        <p>{generatePassword}</p>
                                    </div>
                                }
                            </>
                        )
                    }
                    }
                </Formik>

                <div>
                    <TitleSecondary title={"Justificatifs"}/>
                </div>
                </>
            ) : (<p>Chargement...</p>)}

        </div>);
}

export default UtilisateurCreation;